// Generated by CoffeeScript 2.7.0
var cynamicReviewer;

import FilterOptions from 'trunks/vue/admin/components/filter_options.js';

export default cynamicReviewer = Vue.extend({
  components: {
    'filter-options': FilterOptions
  },
  props: {
    title: String,
    selectedVertexIds: Array,
    previousVerticesUrl: {
      type: String,
      required: true
    }
  },
  template: `<div class="dynamic-reviewer-select">
  <div class="select-wrapper">
    <h4>{{ title }}: </h4>
    <filter-options :multiple='true'
                    position='top'
                    :groupedOptions='previousVertices'
                    @valueChanged='updateReviewerVertexIds' >
      <template slot='option-item-template' slot-scope='{ option }'>
        <div class='content'>{{ option.name }}</div>
        <div class='tip icon'>
          <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
        </div>
      </template>
    </filter-options>
  </div>
</div>`,
  data: function() {
    return {
      previousVertices: []
    };
  },
  created: function() {
    return Skylark.Libs.Ajax.get(this.previousVerticesUrl, {
      success: (data, status, xhr) => {
        return this.setPreviousVertices(data);
      }
    });
  },
  methods: {
    setPreviousVertices: function(data) {
      data.initial_vertex._selected = _.contains(this.selectedVertexIds, data.initial_vertex.id);
      return this.previousVertices = _.reduce(data.previous_vertices, (memo, group) => {
        _.each(group.vertices, (vertex) => {
          return vertex._selected = _.contains(this.selectedVertexIds, vertex.id);
        });
        return memo.concat({
          name: group.name,
          options: group.vertices
        });
      }, [
        {
          options: [data.initial_vertex]
        }
      ]);
    },
    updateReviewerVertexIds: function(select) {
      return this.$emit('valueChanged', {
        vertices_boundary: select.selectedOptions
      });
    }
  }
});
